module.exports = __webpack_public_path__ + "img/smart_main_4.98ac5afa.png";